module.exports = __webpack_public_path__ + "img/semitrailerFrontRightOutline.c8d6b788.svg";